import { DialogProps } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ModalBasic } from "../../../../shared/components/ModalBasic";
import { TModalsIds } from "../../../../app/state/modalSlice/types";
import { AssistantSelect } from "../../../../common/Components/Selects/Components/AssistantSelect";
import { AssistantValue } from "../../../../services/api/instances/assistantsApi/types";
import { NormalizedStorageObject } from "../../../../services/api/instances/storageApi/types/object_types";
import { useAppDispatch } from "../../../../services/redux/hooks/use-dispatch";
import { updateChatbotAssistantAction } from "../../redux/actions";
import { useModalSelectors } from "../../../../app/state/modalSlice/hook/use-modal-selectors";
import styles from "./styles.module.css";

interface Props extends Omit<DialogProps, "open"> {
  assistants: NormalizedStorageObject<AssistantValue>[];
  asstId: string;
  closeModal: (id: TModalsIds) => void;
}

export const ChangeChatAssistantModal = ({
  assistants,
  asstId,
  closeModal,
}: Props) => {
  const dispatch = useAppDispatch();
  const changeChatAssistant = useModalSelectors("change_chat_assistant_modal");
  const [selectedValue, setSelectedValue] =
    useState<NormalizedStorageObject<AssistantValue> | null>(null);
  const { t } = useTranslation();

  useEffect(() => {
    const currentAssistant = assistants.find(
      (a) => a.value?.assistant_object?.id === asstId,
    );
    setSelectedValue(currentAssistant ?? null);
  }, [asstId]);

  const changeAssistant = (
    newAssistant: NormalizedStorageObject<AssistantValue> | null,
  ) => {
    setSelectedValue(newAssistant);
  };

  const handleChangeChatAssistant = useCallback(() => {
    if (!selectedValue?.value?.assistant_object) return;
    dispatch(
      updateChatbotAssistantAction({
        chatId: changeChatAssistant?.info?.id ?? "",
        assistantId: selectedValue?.value?.assistant_object?.id ?? "",
      }),
    );
    closeModal("change_chat_assistant_modal");
  }, [selectedValue, asstId]);

  return (
    <ModalBasic
      open={changeChatAssistant.isOpen}
      title={t("chatbot_dialogs.change_assistant")}
      buttonOkText={t("chatbot_dialogs.change_button")}
      closeModal={() => closeModal("change_chat_assistant_modal")}
      onClose={() => closeModal("change_chat_assistant_modal")}
      onCancel={() => closeModal("change_chat_assistant_modal")}
      onOk={handleChangeChatAssistant}
      hasFooter
      hasHeader
    >
      <div className={styles.body}>
        <AssistantSelect
          assistants={assistants}
          assistant={selectedValue}
          onSelectAssistant={changeAssistant}
        />
      </div>
    </ModalBasic>
  );
};
